import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';

// Hide on routes that already render their own switcher (admin pages
// wrapped in <Sidebar>) and on locked-down kiosk/display screens.
const HIDE_PATTERNS = [
  /^\/admin\/(queue|settings|monitor|analytics)/,
  /^\/(kiosk|display)\//,
];

export default function FloatingLanguageSwitcher() {
  const { pathname } = useLocation();
  // Switcher is pinned to the top of the viewport on desktop and to the
  // bottom on mobile — the menu has to open in the opposite direction or it
  // ends up clipped off-screen.
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches
  );
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  if (HIDE_PATTERNS.some((re) => re.test(pathname))) return null;
  return (
    <>
      <style>{`
        .vq-floating-lang { position: fixed; top: 16px; right: 16px; z-index: 1500; }
        @media (max-width: 768px) {
          .vq-floating-lang { top: auto; right: 16px; bottom: 16px; }
        }
      `}</style>
      <div className="vq-floating-lang">
        <LanguageSwitcher placement={isMobile ? 'up' : 'down'} />
      </div>
    </>
  );
}
